import React from 'react'
import PropTypes from 'prop-types'
import axios from 'axios'
import ReactTooltip from 'react-tooltip'
import Loading from '../general/Loading.js'
import LocationSelect from '../general/LocationSelect.js'
import Search from '../general/Search.js'
import GeneralTd from '../table-componets/GeneralTd.js'
import ButtonTd from '../table-componets/ButtonTd.js'
import LinkTd from '../table-componets/LinkTd.js'
import DateTd from '../table-componets/DateTd.js'

class DigiStorages extends React.Component {
  state = {
    selectedLocationId: '',
    searchText: '',
    page: 1,
    perPage: 25,
    totalPages: 1,
    orderBy: 'uploaded_file_file_name',
    orderDir: 'ASC',
    digiStorages: [],
    loading: true
  }

  componentDidMount() {
    this.buildData()
  }

  buildData() {
    var that = this
    var params = {
      page: this.state.page,
      per_page: this.state.perPage,
      order_by: this.state.orderBy,
      order_dir: this.state.orderDir,
      locations: true,
      users: true,
      method: 'file_size,service_url'
    }

    if (this.state.selectedLocationId) {
      params['location_id'] = this.state.selectedLocationId
    }

    if (this.state.searchText) {
      params['search'] = this.state.searchText
    }

    axios({
      method:'get',
      url:'/digi_storages.json',
      params: params,
      responseType:'json'
    })
    .then(function(response) {
      that.setState({ loading: false })
      that.setState({ digiStorages: response.data })
      that.setState({ totalPages: Math.ceil(response.headers.total / that.state.perPage) })
    })
  }

  newLocation(newLocation) {
    this.setState({ selectedLocationId: newLocation })
    this.setState({ page: 1 })
    this.buildData()
  }

  newSearch(newSearch) {
    this.setState({ searchText: newSearch })
    this.setState({ page: 1 })
    this.buildData()
  }

  sortData(orderBy) {
    if (orderBy == this.state.orderBy) {
      if (this.state.orderDir == 'DESC') {
        this.setState({ orderDir: 'ASC' })
      }
      else {
        this.setState({ orderDir: 'DESC' })
      }
    }
    else {
      this.setState({ orderBy: orderBy })
      this.setState({ orderDir: 'DESC' })
    }

    setTimeout(function() { this.buildData() }.bind(this), 50)
  }

  changePage(increment) {
    var page =  this.state.page +  increment
    this.setState({ page : page })
    setTimeout(function() { this.buildData() }.bind(this), 50)
  }

  copyServiceUrl(digiStorage) {
    toastr.info('Digi Storage URL copied to clipboard')
    navigator.clipboard.writeText(digiStorage.service_url)
  }

  downloadDigiStorage(digiStorage) {
    window.location = '/digi_storages/' + digiStorage.id + '/download'
  }

  deleteDigiStorage(id) {
    if (confirm('Are you sure you want to delete this file?')) {
      var that = this
      var digiStorages = _.reject(this.state.digiStorages, {id: id})

      axios.delete('/digi_storages/' + id)
      .then(function (response) {
        toastr.error('File deleted')
        that.setState({
          digiStorages: digiStorages
        })
      })
      .catch(function (error) {
        toastr.error('File not deleted')
        console.log(error)
      })
    }
  }

  renderPagination() {
    return(
      <div>
        <p>
          {'Showing page ' + this.state.page + ' of ' + this.state.totalPages}
        </p>
        {this.state.page == 1 &&
          <a className='btn btn-default disabled'>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_left
            </i>
          </a>
        }
        {this.state.page != 1 &&
          <a className='btn btn-default'
             onClick={ ()=> this.changePage(-1) }
             tabIndex={0}
             onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                this.changePage(-1)
              }
            }}
             >
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_left
            </i>
          </a>
        }
        {this.state.page < this.state.totalPages &&
          <a className='btn btn-default'
             onClick={ ()=> this.changePage(1) }
             tabIndex={0}
             onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                this.changePage(1)
              }
            }}
             >
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_right
            </i>
          </a>
        }
        {this.state.page == this.state.totalPages &&
          <a className='btn btn-default disabled'>
            <i className='material-icons progress-bar-icon'>
              keyboard_arrow_right
            </i>
          </a>
        }
      </div>
    )
  }

  renderBody() {
    var that = this
    var digiStorages = []

    _.forEach(this.state.digiStorages, function(digiStorage, index) {
      digiStorages.push(
        <tr key={index}>
          <td></td>
          <GeneralTd fieldValue={digiStorage.uploaded_file_file_name} />
          <GeneralTd fieldValue={digiStorage.location_id ? digiStorage.location.name : 'All Locations'} />
          <GeneralTd fieldValue={digiStorage.file_size} />
          <DateTd fieldValue={digiStorage.created_at}
                  fieldFormat='M/D/YYYY'
                  fieldInsideClassName='pull-right' />
          <LinkTd fieldName={digiStorage.user.last_name + ', ' + digiStorage.user.first_name}
                  fieldURL={'/users/' + digiStorage.user.id} />
          <td>
            <ReactTooltip />
            <span
              className='material-icons pointer-hand styled-link icon-in-row margin-right-five'
              style={{width: '20px'}}
              onClick={ ()=> that.copyServiceUrl(digiStorage) }
              tabIndex={0}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') { that.copyServiceUrl(digiStorage) }
              }}
              data-tip='Copy URL'
            >
              link_2
            </span>
            <span className='material-icons pointer-hand styled-link icon-in-row margin-right-five'
                  style={{width: '20px'}}
                  onClick={ ()=> that.downloadDigiStorage(digiStorage) }
                  tabIndex={0}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                      that.downloadDigiStorage(digiStorage)
                    }
                  }}
                  data-tip='Download'
                  >
              file_download
            </span>
            {that.props.currentUser.admin &&
              <span className='material-icons pointer-hand styled-link icon-in-row'
                    style={{width: '20px'}}
                    onClick={ ()=> that.deleteDigiStorage(digiStorage.id) }
                    tabIndex={0}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter' || e.key === ' ') {
                        that.deleteDigiStorage(digiStorage.id)
                      }
                    }}
                    data-tip='Delete'
                    >
                delete
              </span>
            }
          </td>
          <td></td>
        </tr>
      )
    })

    return (
      <tbody>
        {digiStorages}
      </tbody>
    )
  }

  renderCards() {
    var that = this
    var digiStorages = []

    _.forEach(this.state.digiStorages, function(digiStorage, index) {
      digiStorages.push(
        <div key={index}
             className='well shadowDepth1'>
          <div className='row'>
            <div className='col-xs-12 col-sm-12'>
              {that.props.currentUser.admin &&
                <a onClick={()=> that.deleteDigiStorage(digiStorage) }
                   className='btn btn-text pull-right'>
                  DELETE
                </a>
              }
              <a onClick={()=> that.downloadDigiStorage(digiStorage) }
                 className='btn btn-text pull-right pull-right'>
                DOWNLOAD
              </a>
            </div>
            <div className='col-xs-12'>
              <p>
                {digiStorage.location_id ? digiStorage.location.name : 'All Locations'}
                <br />
                <span className='margin-right-five'>
                  {moment(digiStorage.created_at).format('M/D/YYYY @ h:mma')} |
                </span>
                <br />
                <a href={'/users/' + digiStorage.user_id}
                   className='styled-link'>
                  {digiStorage.user.last_name + ', ' + digiStorage.user.first_name}
                </a>
              </p>
            </div>
          </div>
          <p className='grey-text word-wrap'>
            {digiStorage.uploaded_file_file_name}
          </p>
        </div>
      )
    })

    return (
      <div>
        {digiStorages}
      </div>
    )
  }

  render() {
    var that = this

    return(
      <div>
        <h1>
          DigiStorage
        </h1>
        <div className='row'>
          <LocationSelect
            locationId={this.props.locationId}
            locations={this.props.locations}
            selectClassName='col-md-3 col-xs-12'
            newLocationCallback={(newLocation) => this.newLocation(newLocation) }/>
          <Search
            newSearchCallback={(newSearch) => this.newSearch(newSearch) }/>
          {this.props.currentUser.admin &&
            <div className='col-md-6 pull-right'>
              <div className='pull-right'>
                <a className='btn btn-pink btn-raised btn-long'
                   href='/digi_storages/new'>
                  UPLOAD
                </a>
                <br className='visible-xs visible-sm' />
            </div>
            </div>
          }
        </div>
        <br />
        {that.state.digiStorages.length ? (
          <div>
            <div className='hidden-xs hidden-sm'>
              <table className='table table-clean table-white'>
                <thead>
                  <tr>
                    <th></th>
                    <th
                      onClick={() => this.sortData('uploaded_file_file_name')}
                      tabIndex="0"
                      onKeyDown={(e) => { if (e.key === 'Enter') this.sortData('uploaded_file_file_name'); }}
                    >
                      <a
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Name"
                      >
                        Name
                      </a>
                    </th>
                    <th
                      onClick={() => this.sortData('locations-name')}
                      tabIndex="0"
                      onKeyDown={(e) => { if (e.key === 'Enter') this.sortData('locations-name'); }}
                    >
                      <a
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Location"
                      >
                        Location
                      </a>
                    </th>
                    <th
                      onClick={() => this.sortData('uploaded_file_file_size')}
                      tabIndex="0"
                      onKeyDown={(e) => { if (e.key === 'Enter') this.sortData('uploaded_file_file_size'); }}
                    >
                      <a
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by File Size"
                      >
                        Size
                      </a>
                    </th>
                    <th
                      onClick={() => this.sortData('created_at')}
                      className="pull-right"
                      tabIndex="0"
                      onKeyDown={(e) => { if (e.key === 'Enter') this.sortData('created_at'); }}
                    >
                      <a
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Uploaded Date"
                      >
                        Uploaded
                      </a>
                    </th>
                    <th
                      onClick={() => this.sortData('users-last_name')}
                      tabIndex="0"
                      onKeyDown={(e) => { if (e.key === 'Enter') this.sortData('users-last_name'); }}
                    >
                      <a
                        className="styled-link pointer-hand"
                        role="button"
                        aria-label="Sort by Submitted By"
                      >
                        Submitted By
                      </a>
                    </th>
                    <th></th>
                  </tr>
                </thead>
                {this.renderBody()}
              </table>
            </div>
            <div className='visible-xs visible-sm'>
              {that.renderCards()}
            </div>
            {this.renderPagination()}
          </div>
        ) : (
          <Loading loading={this.state.loading}
                   noDataMessage='No files uploaded' />
        )}
      </div>
    )
  }
}

DigiStorages.propTypes = {
  currentUser: PropTypes.object,
  locations: PropTypes.array
}

export default DigiStorages
